/* eslint-disable import/prefer-default-export */

import { getSupportedDeepLink } from '../utils/deepLinkUri';

import { showInviteModal } from './inviteActions';

export function dispatchDeepLink(deepLinkUri) {
  const deepLink = getSupportedDeepLink(deepLinkUri);

  if (!deepLink) {
    return Promise.resolve();
  }

  return (dispatch) => {
    switch (deepLink) {
      case 'MGM_INVITE_MODAL': {
        return dispatch(showInviteModal());
      }
      default: {
        return Promise.resolve();
      }
    }
  };
}
